import ErrorService from './service';

export const errorService = new ErrorService();
